import { Prose } from '../../components/Prose'
const A: [string, string][] = [
  ['Sandalye squat — 3 × 10 → 15', 'Sandalyeye otur-kalk. İnişi 3 saniyede yap, hızlı düşme.'],
  ['Tezgâh şınavı — 3 × 10 → 15', 'Mutfak tezgâhına yaslan. Ağırlığın fazlaysa yerde yapma, omuz sıkıştırır.'],
  ['Bant kürek (oturarak) — 3 × 12', 'Bandı ayak tabanına dola, göbeğe doğru çek. Kürek kemiklerini yaklaştır.'],
  ['Kalça köprüsü — 3 × 15', 'Sırtüstü yat, kalçayı yukarı it, tepede 1 sn sık.'],
  ['Plank — 3 × 20 → 40 sn', 'Zorsa dizden yap. Bel çukurlaşmasın.'],
]

const B: [string, string][] = [
  ['Bant göğüs press — 3 × 12', 'Bandı sırtından geçir, iki ucu tut, öne it.'],
  ['Bant omuz press — 3 × 12', 'Bandın ortasına bas, yukarı it.'],
  ['Sandalye destekli hamle — her bacak 3 × 8', 'Dengeni sandalyeden al. Ön diz parmak ucunu geçmesin.'],
  ['Bant pull-apart — 3 × 15', 'Kollar önde düz, bandı iki yana aç. Öne kapanan omuzun ilacı.'],
  ['Dead bug — 3 × 10', 'Sırtüstü, karşıt kol-bacak uzat. Bel yere yapışık kalsın.'],
]

const PROGRESSION: [string, string, string][] = [
  ['Squat', 'Sandalye squat 3×15', 'Sandalyeye değmeden yarım squat 3×12, sonra tam squat'],
  ['İtme', 'Tezgâh şınavı 3×15', 'Sandalye/basamak şınavı 3×10 (açı düştükçe zorlaşır)'],
  ['Çekme', 'Bant kürek 3×12', 'Bandı kısalt (3×12) + tek kol kürek 3×10'],
  ['Kalça', 'Kalça köprüsü 3×15', 'Tek bacak kalça köprüsü 3×10'],
  ['Karın', 'Plank 40 sn', 'Plank 60 sn + yan plank 3×20 sn'],
  ['Bacak (tek)', 'Destekli hamle 3×8', 'Bulgar split squat (arka ayak sandalyede) 3×8'],
]

export function WorkoutTab() {
  return (
    <>
      <div className="card" style={{ borderLeft: '3px solid var(--s1)' }}>
        <h2>İlk 8 hafta: ev programı</h2>
        <p style={{ color: 'var(--ink-2)', fontSize: 14.5, margin: '6px 0 0' }}>
          Evde başlamak makul bir karar: salon kapı-kapı 90 dakikalık bir iş ve üşendiği için hiç
          yapılmayan mükemmel program, evde yapılan orta programdan kötüdür. 8 hafta evde çalış,
          alışkanlık otursun, sonra istersen salona geç.
        </p>
        <p style={{ color: 'var(--ink-2)', fontSize: 14.5, margin: '10px 0 0' }}>
          <strong>Bir direnç bandı</strong> bu programın en değerli parçası. Ekipmansız ev antrenmanının tek
          gerçek eksiği çekme hareketleridir (sırt, biseps) — bandın onu çözüyor.
        </p>
        <div className="warnbox">
          <strong>Bandı her kullanımdan önce kontrol et.</strong> Uçlarında çatlak, incelme veya yırtık varsa kullanma —
          gerilmiş bir bant koptuğunda yüze gelir. Ayağına dolarken kaymayacağından da emin ol.
        </div>
      </div>

      <div className="card">
        <h2>Hafta 1–4 · Temel (3 gün, 25–30 dk)</h2>
        <Prose className="card-h">Pazartesi / Çarşamba / Cuma. Setler arası 60 sn. İlk 2 hafta hafif kal, hareketi öğren.</Prose>
        <div className="grid g2">
          <div className="day">
            <div className="dn">Antrenman A</div>
            <ul className="tight" style={{ fontSize: 13.5 }}>
              {A.map(([t, d]) => <li key={t}><strong>{t}</strong><br /><span style={{ color: 'var(--muted)' }}>{d}</span></li>)}
            </ul>
          </div>
          <div className="day">
            <div className="dn">Antrenman B</div>
            <ul className="tight" style={{ fontSize: 13.5 }}>
              {B.map(([t, d]) => <li key={t}><strong>{t}</strong><br /><span style={{ color: 'var(--muted)' }}>{d}</span></li>)}
            </ul>
          </div>
        </div>
        <Prose className="note">Haftada 3 gün: A – B – A, sonraki hafta B – A – B.</Prose>
      </div>

      <div className="card">
        <h2>Hafta 5–8 · Zorlaştırma</h2>
        <Prose className="card-h">Bu geçişi tekrarları tamamlayabildiğinde yap, takvime bakarak değil.</Prose>
        <table>
          <thead><tr><th>Hareket</th><th>Hafta 1–4</th><th>Hafta 5–8</th></tr></thead>
          <tbody>
            {PROGRESSION.map(([k, a, b]) => (
              <tr key={k}><td>{k}</td><td style={{ fontVariantNumeric: 'normal' }}>{a}</td><td style={{ fontVariantNumeric: 'normal' }}>{b}</td></tr>
            ))}
          </tbody>
        </table>
        <div className="warnbox">
          <strong>Yükleme kuralı:</strong> Üç setin hepsini hedef tekrarın üstünde, son tekrarda zorlanmadan
          bitirebiliyorsan bir sonraki zorluğa geç. Acele etmenin faydası yok — sakatlık 3 hafta kaybettirir.
        </div>
      </div>

      <div className="card">
        <h2>Bandını tanı</h2>
        <Prose className="card-h">
          "30 kg" etiketi bandın tam gerildiğindeki üst direnci — sabit bir ağırlık değil. Kilo değil,
          <strong> tekrar</strong> üzerinden ayarla:
        </Prose>
        <ul className="tight">
          <li><strong>15 tekrarı rahat yapıyorsan</strong> → bandı kısalt ya da ayağına bir tur daha dola.</li>
          <li><strong>8 tekrarda formun bozuluyorsa</strong> → bandı uzat, direnci düşür.</li>
          <li><strong>Doğru ayar:</strong> son 2 tekrar zorlanacak ama form bozulmayacak.</li>
          <li><strong>Tek kolla çalışmak</strong> direnci pratikte ikiye katlar — 30 kg hafif gelmeye başlarsa ilk çözüm bu, yeni bant almak değil.</li>
        </ul>
      </div>

      <div className="card">
        <h2>Adım hedefi — kademeli</h2>
        <table>
          <thead><tr><th>Hafta</th><th>Günlük adım</th><th>Nasıl</th></tr></thead>
          <tbody>
            <tr><td>1–2</td><td>7.000</td><td style={{ fontVariantNumeric: 'normal' }}>Mola sayacı + öğle yürüyüşü</td></tr>
            <tr><td>3–4</td><td>8.500</td><td style={{ fontVariantNumeric: 'normal' }}>+ toplantıları yürüyerek al</td></tr>
            <tr><td>5–8</td><td>10.000</td><td style={{ fontVariantNumeric: 'normal' }}>+ akşam 30–40 dk yürüyüş</td></tr>
            <tr><td>9+</td><td>10.000 sabit</td><td style={{ fontVariantNumeric: 'normal' }}>Artırma, koru. Sürdürülebilirlik &gt; rekor</td></tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
